import type {
  AllowedFrameStyle,
  CardViewerConfig,
  HighnoteEnvironment,
  PaymentCardFields,
} from "@highnoteplatform/types";

import { iframeUri } from "./config";

type BuildFrameConfig =
  | {
      uuid: string;
      field: PaymentCardFields;
      environment: HighnoteEnvironment;
      styles?: AllowedFrameStyle;
      enableClipboard?: boolean;
    }
  | (Pick<CardViewerConfig, "clientToken" | "paymentCardId"> & {
      uuid: string;
      environment: HighnoteEnvironment;
      styles?: AllowedFrameStyle;
      enableClipboard?: boolean;
      maskedOnLoad: boolean;
    });

export const buildFrame = (
  config: Readonly<BuildFrameConfig>
): HTMLIFrameElement => {
  const frame = document.createElement("iframe");

  const frameSource = new URL(
    "clientToken" in config
      ? `${iframeUri(config.environment)}?field=cardNumber&token=${
          config.clientToken
        }&environment=${config.environment}&paymentCardId=${
          config.paymentCardId
        }&styles=${encodeURIComponent(
          JSON.stringify(config.styles ?? {})
        )}&enableClipboard=${
          config.enableClipboard ? "true" : "false"
        }&maskedOnLoad=${config.maskedOnLoad ? "true" : "false"}`
      : `${iframeUri(config.environment)}?field=${
          config.field
        }&styles=${encodeURIComponent(
          JSON.stringify(config.styles ?? {})
        )}&enableClipboard=${config.enableClipboard ? "true" : "false"}`
  );

  frameSource.hash = config.uuid;

  frame.setAttribute("src", frameSource.toString());
  frame.setAttribute("allow", "clipboard-write");
  frame.style.setProperty("border", "none");

  return frame;
};
